enum EvaluationSubmittedEventType {
    ASSIGNED = "ASSIGNED",
    ASSIGNEE_CHANGED = "ASSIGNEE_CHANGED",
    ASSIGNMENT_RESCINDED = "ASSIGNMENT_RESCINDED",
    INPROGRESS = "INPROGRESS",
    SUBMITTED = "SUBMITTED",
    SUBMISSION_RESCINDED = "SUBMISSION_RESCINDED",
    SIGNED_OFF = "SIGNED_OFF",
    DELETED = "DELETED",
    RELEASED = "RELEASED",
    ROLLBACK = "ROLLBACK",
    AI_SCORED = "AI_SCORED",
}

export default EvaluationSubmittedEventType;
